import { button } from "./button";
import { form } from "./form";
import { grid } from "./grid";
import { link } from "./links";

export const components = {
  button,
  form,
  grid,
  link,
};
